import { isMoment, Moment } from 'moment';

type QueryPrimitive = string | number | boolean | null | undefined;
type QueryValue = QueryPrimitive | Moment;
type QueryObject = { [key: string]: QueryValue | QueryValue[] | QueryObject };

export const formatObjectForQuery = (
	obj: QueryObject,
	encode = false,
): string => {
	const params: string[] = [];

	const buildParams = (key: string, value: any) => {
		if (value === null || value === undefined) {
			return;
		}

		if (isMoment(value)) {
			params.push(`${key}=${value.format('YYYY-MM-DD HH:mm:ss')}`);
		} else if (Array.isArray(value)) {
			const formattedArray = value
				.map(item => {
					if (isMoment(item)) {
						return item.format('YYYY-MM-DD HH:mm:ss');
					}
					return item;
				})
				.join(',');
			params.push(`${key}=${formattedArray}`);
		} else if (typeof value === 'object') {
			for (const subKey in value) {
				if (Object.prototype.hasOwnProperty.call(value, subKey)) {
					buildParams(`${key}[${subKey}]`, value[subKey]);
				}
			}
		} else {
			params.push(`${key}=${value}`);
		}
	};

	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			buildParams(key, obj[key]);
		}
	}

	const queryString = params.join('&');
	return encode ? encodeURI(queryString) : queryString;
};
